<script lang="ts">
	interface Props {
		className?: string;
		strokeWidth?: string;
	}

	let { className = '', strokeWidth = '1.3' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g
			id="SVGRepo_iconCarrier"
			stroke="currentColor"
			stroke-width={strokeWidth}
			stroke-linecap="round"
		>
			<circle cx="10" cy="6" r="4"></circle>
			<path d="M19 2C19 2 21 3.2 21 6C21 8.8 19 10 19 10"></path>
			<path d="M17 4C17 4 18 4.6 18 6C18 7.4 17 8 17 8"></path>
			<path
				d="M17.9975 18C18 17.8358 18 17.669 18 17.5C18 15.0147 14.4183 13 10 13C5.58172 13 2 15.0147 2 17.5C2 19.9853 2 22 10 22C12.231 22 13.8398 21.8433 15 21.5634"
			></path>
		</g>
	</svg>
</div>
